import React from "react";
import { renderRichText, storyblokEditable } from "gatsby-source-storyblok";
 
const Text = ({ blok }) => {
  const html = renderRichText(blok.text_content);
  const textAlign = blok.text_align || '';

  return(
    <div {...storyblokEditable(blok)} key={blok._uid} className={"text component " + textAlign} dangerouslySetInnerHTML={{__html: html}} style={{maxWidth :blok.max_width + "px"}} />
  )
};
 
export default Text;